/**
 * Global requires
 */
const $ = require('jquery')
window.$ = $ || {}

/**
 * Components
 */
require('./components/swiper')
require('./components/animation')
require('./components/pagination')

/**
 * Snippets
 */
require('./snippets/gated-form')
require('./snippets/navigation')
require('./snippets/share-popup')
require('./snippets/cookie-banner')
require('./snippets/header-banner')

/**
 * Blocks
 */
require('../../app/blocks/form/script')
require('../../app/blocks/tips/script')
require('../../app/blocks/rebates/script')
require('../../app/blocks/accordion/script')
require('../../app/blocks/contractors/script')
require('../../app/blocks/contractor-search/script')
require('../../app/blocks/temperature-tracker/script')